import { usePermissions } from "ra-core";
import { Navigate } from "react-router";

/** /courriels → campaigns for admins, sequences for reps. */
export const EmailIndexRedirect = () => {
  const { permissions, isPending } = usePermissions();
  if (isPending) return null;
  return (
    <Navigate
      to={permissions === "admin" ? "campagnes" : "sequences"}
      replace
    />
  );
};
